import { render, staticRenderFns } from "./TreatmentListItem.vue?vue&type=template&id=9fb50980&scoped=true&lang=pug&"
import script from "./TreatmentListItem.vue?vue&type=script&lang=js&"
export * from "./TreatmentListItem.vue?vue&type=script&lang=js&"
import style0 from "./TreatmentListItem.vue?vue&type=style&index=0&id=9fb50980&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fb50980",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VIcon,VSkeletonLoader,VSpacer})
